import { MsalInterceptorConfiguration } from '@azure/msal-angular';
import { Configuration } from '@azure/msal-browser';
import { AppEnvironment, AppEnvironmentLabel } from 'src/app/models';
import { environment as base } from './environment.base';

export const sapProxyUrl = 'https://sappx1c00.sap.corp.lego.com:22000/sap/opu/odata/sap';

const msalInterceptorConfig: MsalInterceptorConfiguration = {
  ...base.msalInterceptorConfig,
  protectedResourceMap: new Map([
    [
      `${window.location.origin}/bom-header/*`,
      ['api://e9c40aa6-654b-47c7-b370-3f2558b05d6b/.default'],
    ],
    [
      `${window.location.origin}/bom-item/*`,
      ['api://e9c40aa6-654b-47c7-b370-3f2558b05d6b/.default'],
    ],
    [
      `${window.location.origin}/notification/*`,
      ['api://e9c40aa6-654b-47c7-b370-3f2558b05d6b/.default'],
    ],
    [
      `${window.location.origin}/notification-activity/*`,
      ['api://e9c40aa6-654b-47c7-b370-3f2558b05d6b/.default'],
    ],
    [
      `${window.location.origin}/material-data/*`,
      ['api://e9c40aa6-654b-47c7-b370-3f2558b05d6b/.default'],
    ],
    [
      `${window.location.origin}/project/*`,
      ['api://e9c40aa6-654b-47c7-b370-3f2558b05d6b/.default'],
    ],
    [
      `${window.location.origin}/equipment/*`,
      ['api://e9c40aa6-654b-47c7-b370-3f2558b05d6b/.default'],
    ],
    [`${window.location.origin}/api/*`, ['api://e9c40aa6-654b-47c7-b370-3f2558b05d6b/.default']],
    [`${window.location.origin}/proxy/*`, ['api://e9c40aa6-654b-47c7-b370-3f2558b05d6b/.default']],
  ]),
};

const msalConfig: Configuration = {
  ...base.msalConfig,
  auth: {
    ...base.msalConfig.auth,
    postLogoutRedirectUri: 'https://emmet.engineering.corp.lego.com/logged-out',
    redirectUri: 'https://emmet.engineering.corp.lego.com',
  },
};

export const environment = {
  ...base,
  environmentName: AppEnvironment.PROD,
  environmentLabel: AppEnvironmentLabel.PROD,
  legoRestApiUrl: `https://dkatcpp-t1.corp.lego.com/LEGORESTAPI/rest/item/P`,
  msalConfig,
  msalInterceptorConfig,
  production: true,
  sapUrl: sapProxyUrl,
  sharePointEHDDriveId: 'b!gUZ2Dln2E0ycFx_AcZ2nuENmg3Teg7RLjebzQNjOEB71FWrDvfo4TIZVTCx-XitR',
  sharePointEHDSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/ElementHistoryDocument/Novelty%20Elements/Forms/EHD%20All.aspx'
  ),
  sharePointERADriveId: 'b!wX24Yl5250yqrvtHTnNNxNYlHIZAv59JjfyqK0VxLOeka16cSHRBToPAb5hyfnZr',
  sharePointERASiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/Elements/RiskAssessment/Forms/Search%20View.aspx'
  ),
  sharePointMDTDriveId: 'b!eSGzXbtEIUGFmD7oi2QF5xzZDW0fcfpJht7agdMeFGqSQVDvIPObRqw8GVuwS9hl',
  sharePointMDTSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/MouldDecisionProces/MDT/Forms/AllItems.aspx'
  ),
  sharePointPHDDriveId: 'b!LFWem6lej0ShcqrtW1IlKkf28Svov7RMtgnwYzhDmbQZr7n2gZ6JT5-sJyoNw7Kx',
  sharePointPHDSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/ProcessingDrivers/test2/Forms/EHD%20All.aspx'
  ),
  sharePointSiriusEHDDriveId: 'b!gUZ2Dln2E0ycFx_AcZ2nuENmg3Teg7RLjebzQNjOEB7P3TdksZYGQ4nStdDX0M-7',
  sharePointSiriusEHDSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/ElementHistoryDocument/Sirius_EHD/Forms/AllItems.aspx'
  ),
  sharePointTRDriveId: 'b!wX24Yl5250yqrvtHTnNNxNYlHIZAv59JjfyqK0VxLOeUTiHnNI-UTJBIZ0XdqU3f',
  sharePointTRSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/Elements/TechnicalReview/Forms/AllItems.aspx'
  ),
  sharePointTSRSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/Elements/ToySafetyReport/Forms/All%20Documents%20by%20Design%20ID.aspx'
  ),
  sharePointVisitationDriveId: 'b!6f6rMDd9E0i1h1W1a_rXyepI-vIHms5BgjKXoO8o2jCRwvytj-y2Q4OSO071LAIB',
  sharePointVisitationSiteUrl: new URL(
    'https://legogroup.sharepoint.com/sites/NoveltyVisitation/Visitation%20Library%20all%20order%20types/Forms/AllItems.aspx'
  ),
  teamcenter: 'https://tcsoa.tcplat-bll.prod.novus.internal.lego/workflow/v1/prod',
  optimizelySdkKey: 'QNVzNZQZwEnY8yinPuwAC',
};
